const InDocDiagramFrame = ({ theme, children, caption, className = '' }) => {
  const isDark = theme === 'dark';

  return (
    <figure className={className}>
      <div
        className={`indoc-diagram-shell relative overflow-hidden rounded-xl border ${
          isDark
            ? 'border-sky-900/50 bg-[#070b14] shadow-[0_20px_50px_rgba(0,0,0,0.4)]'
            : 'border-sky-200/80 bg-[#f4f7fb] shadow-[0_18px_40px_rgba(2,132,199,0.08)]'
        }`}
      >
        <div
          className={`pointer-events-none absolute inset-x-0 top-0 h-px ${
            isDark
              ? 'bg-gradient-to-r from-transparent via-sky-500/60 to-transparent'
              : 'bg-gradient-to-r from-transparent via-sky-600/40 to-transparent'
          }`}
        />
        <div className="relative">{children}</div>
      </div>
      {caption && (
        <figcaption
          className={`mt-3 text-[11px] uppercase tracking-[0.2em] text-center leading-snug ${
            isDark ? 'text-slate-500' : 'text-slate-400'
          }`}
        >
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

export default InDocDiagramFrame;
